import { useFacets,useProductFilters } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { isVisualFilter } from "../helpers"

import Facet from "./Facet"
import RangeFacet from "./RangeFacet"

export default function SideBar({ sidebarOpen, closeSidebar }) {
    const { facets } = useFacets();
    const { filters, removeAll } = useProductFilters();

    useEffect(() => {
        document.body.style.overflow = sidebarOpen ? 'hidden' : '';
        return () => document.body.style.overflow = '';
    }, [ sidebarOpen ]);

    return facets?.length > 0 ? (
        <>
            <aside
                class="ns-flex ns-flex-col ns-fixed"
                id="ns-sidebar"
                role="dialog"
                aria-hidden={!sidebarOpen}
                aria-modal="true"
                aria-label="Filter options"
            >

                <div class="ns-sidebar-header ns-relative ns-flex ns-flex-nowrap ns-items-center ns-justify-between">
                    <h2 class="ns-folio-reg">Filters</h2>
                    <button
                        type="button"
                        aria-controls="ns-sidebar"
                        onClick={closeSidebar}
                    >
                        <span class="sr-only visually-hidden">Close filters</span>
                        <svg aria-hidden="true" role="presentation" width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.70573 6.5023L13.0076 11.8042L12.3005 12.5113L6.99862 7.20941L1.69808 12.5099L0.990974 11.8028L6.29151 6.5023L0.98683 1.19762L1.69394 0.490511L6.99862 5.79519L12.3047 0.48913L13.0118 1.19624L7.70573 6.5023Z" fill="black"/>
                        </svg>
                    </button>
                </div>
                
                <div class="ns-sidebar-body">
                    <ul>
                        {facets?.map(facet => {
                            if(isVisualFilter(facet.name)) return null;
                            switch (facet.type) {
                                case "terms":
                                    return <Facet key={facet.id} facet={facet} />
                                case "stats":
                                    return <RangeFacet key={facet.id} facet={facet} />
                                default:
                                    return null
                            }
                        })}
                    </ul>
                </div>

                <div class="ns-sidebar-footer ns-flex ns-items-center ns-justify-center">
                    <button
                        class="ns-btn ns-folio-reg ns-btn-secondary"
                        type="button"
                        disabled={filters.length < 1}
                        onClick={removeAll}
                    >
                        Clear Filters
                    </button>

                    <button
                        class="ns-btn ns-folio-reg ns-btn-primary"
                        type="button"
                        onClick={closeSidebar}
                    >
                        Apply
                    </button>
                </div>
            </aside>

            <div
                class="ns-sidebar-backdrop ns-fixed"
                aria-label="Close filters list"
                aria-controls="ns-sidebar"
                role="button"
                tabIndex="-1"
                aria-hidden={!sidebarOpen}
                onClick={closeSidebar}
            />
        </>
    ) : ( null )
}
